import React, { useContext } from 'react';
import { Box } from '@warp-ds/react';
import LinkExternal from '@warp-ds/icons/react/link-external-16';
import { onGDPRTakeout } from '../consent-tracking.js';
import { Config } from '../../config.js';
import TranslationContext from '../translation-context.js';
import { Trans } from '@lingui/react';

export type TakeoutProps = Pick<Config, 'links'>;

export default function Takeout({ links }: TakeoutProps): React.ReactElement {
    const { texts } = useContext(TranslationContext);
    return (
        <Box bleed info className="mb-16 s-border border-1">
            <h3 className="text-m">
                <Trans id="privacy-settings.takeout.header" values={texts} />
            </h3>
            <div className="schibsted-privacy">
                <p className="text-s mr-16">
                    <Trans id="privacy-settings.takeout.text" values={texts} />
                </p>
                <a
                    href={links.takeoutUrl as string}
                    className="button button--small"
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={onGDPRTakeout}
                >
                    <div className="inline-flex items-center whitespace-nowrap">
                        <span className="mr-4">
                            <Trans
                                id="privacy-settings.takeout.link"
                                values={texts}
                            />{' '}
                        </span>
                        <LinkExternal height={12} width={12} />
                    </div>
                </a>
            </div>
        </Box>
    );
}
